export const LINK_CONTACT_SPI_TEAM_EMAIL = 'england.invitationservicessupport@nhs.net';
export const LINK_SPI_GUIDANCE = 'https://nhsd-confluence.digital.nhs.uk/display/Vacc/Select+People+for+Invitation+%28SPI%29+Guidance';
export const LINK_SPI_RELEASE_NOTES = 'https://nhsd-confluence.digital.nhs.uk/display/Vacc/Select+People+for+Invitations+releases';
export const LINK_NHS_NOTIFY = 'https://notify.nhs.uk/templates/message-plans';

export const INTENDED_URL = 'intended-url';
